// SocialMediaIcons
import React from 'react';
import TelegramIcon from '@mui/icons-material/Telegram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SubscriptionsIcon from '@mui/icons-material/Subscriptions';

const SocialMediaIcons = () => {
    const items = [
        {
            icon: <TelegramIcon />,
            href: "https://www.google.com/",
            text: "telegram"
        },
        {
            icon: <YouTubeIcon />,
            href: "https://www.youtube.com/",
            text: "youtube"
        },
        {
            icon: <SubscriptionsIcon />,
            href: "https://www.google.com/",
            text: "subscribe"
        },
    ];

    return (
        <div className="socialMediaIcons">
            {items.map((item, index) => (
                <a
                    key={index}
                    className="socialMediaIcons__container"
                    href={item.href}
                    aria-label={item.text}
                    target="_blank"
                    rel="noreferrer"
                >
                    {item.icon}
                </a>
            ))}
        </div>
    );
};

export default SocialMediaIcons;